import { useQuery } from "@tanstack/react-query";

import { getExternalTeamService, getInternalTeamService } from "@/services/team.service";
import {
  ExternalTeamParams,
  ExternalTeamResponse,
  InternalTeamParams,
  InternalTeamResponse,
} from "@/types/team.types";

export const teamQueryKeys = {
  all: () => ["team"] as const,
  internal: (params: InternalTeamParams) => [...teamQueryKeys.all(), "internal", params] as const,
  external: (params: ExternalTeamParams) => [...teamQueryKeys.all(), "external", params] as const,
};

export const useGetInternalTeam = (params: InternalTeamParams = {}, { enabled = true } = {}) =>
  useQuery<InternalTeamResponse, Error>({
    queryKey: teamQueryKeys.internal(params),
    queryFn: () => getInternalTeamService(params),
    enabled,
  });

export const useGetExternalTeam = (params: ExternalTeamParams = {}, { enabled = true } = {}) =>
  useQuery<ExternalTeamResponse, Error>({
    queryKey: teamQueryKeys.external(params),
    queryFn: () => getExternalTeamService(params),
    enabled,
  });
